import api from '../baseAPIs/shopify';

export const confirmSubscription = async (
    store: string,
    chargeId: string,
    timestamp: string,
    nonce: string,
    key: string,
    storeType = 'shopify',
    collectiveRetail?: string
): Promise<{
    redirectUrl: string;
}> => {
    const response = await api.post(`payment/${storeType}/${store}/confirmed`, undefined, {
        params: {
            chargeId: chargeId,
            timestamp: timestamp,
            nonce: nonce,
            key: key,
            collectiveRetail: collectiveRetail
        }
    });
    return response.data;
};

export const forceStoreResubscribe = async (store: string, sendEmail = true): Promise<void> => {
    await api.post('payment/force-resubscribe', undefined, {
        params: { shop: store, sendEmail }
    });
};

export const getApplicationCharge = async (
    store: string,
    key: string
): Promise<{
    charge_id: string;
}> => {
    const response = await api.get(`payment/shoplazza/${store}/applicationCharge`, {
        params: {
            hash: key
        }
    });
    return response.data;
};
